import { GetterTree } from 'vuex/types/index'
import { RootState } from '~/store/store.types'
import { getResource } from '~/utils/store'
import { Attachment, AttachmentsState, AttachmentResource } from './attachments.types'

const getters: GetterTree<AttachmentsState, RootState> = {
  attachments (state, getters, rootState, rootGetters): Attachment[] {
    return Object.values(state.data).map(({ id }) => getResource<AttachmentResource>(state, id, rootGetters))
  },

  attachmentById (state) {
    return (attachmentId: string) => {
      return getResource<AttachmentResource>(state, attachmentId)
    }
  }
}

export default getters
